module.exports = __webpack_public_path__ + "img/zhuanpan.3b01aa18.gif";